import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { servicePath } from "@travily/routes";
import type ListingsEditorShow from "@travily/types/pages/ListingsEditorShow";
import type { ReactNode } from "react";
import { EditFrame } from "@/layouts/edit-frame";
import PersistentLayout from "@/layouts/persistent-layout";
import { buildEditorSections } from "@/lib/editor-sections";
import { ServiceEditorSectionsView } from "./show.view";

const ServiceEditIndexPage = (props: ListingsEditorShow) => {
  const sections = buildEditorSections(props);
  const title = t("web.services.editors.show.title");

  return (
    <EditFrame
      backHref={servicePath(props.listing_id)}
      href={servicePath(props.listing_id)}
      sections={sections}
      title={title}
    >
      <Head title={t("web.services.editors.show.meta_title", { title: props.listing_title ?? "" })} />
      <ServiceEditorSectionsView sections={sections} title={title} />
    </EditFrame>
  );
};

ServiceEditIndexPage.layout = (page: ReactNode) => <PersistentLayout>{page}</PersistentLayout>;

export default ServiceEditIndexPage;
